import { render, staticRenderFns } from "./candidateSubmissionRequest.vue?vue&type=template&id=3154be8c&"
import script from "./candidateSubmissionRequest.vue?vue&type=script&lang=js&"
export * from "./candidateSubmissionRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports